import { useContentfulLiveUpdates } from '@contentful/live-preview/react'
import resolveResponse from 'contentful-resolve-response'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useContentAPI } from '../../Hooks/useAPI'
import { usePageInfoContext } from '../Contexts/PageInfoContext'
import SEOMeta from '../atoms/SEOMeta'
import HeroBanner from '../molecules/HeroBanner'
import SearchResults from '../molecules/SearchResults'
import DynamicComponent from '../organisms/Dynamic/Dynamic'
import PageBanner from '../organisms/PageBanner'
import ContainerSection from './layout/ContainerSection'
import { SEOProvider } from '../../context/SEOContext'

const BaseTemplate = () => {
  const [contentData, setContentData] = useState<any>({})
  const [count, setCount] = useState(0)

  const params = useParams()
  const paths = Object.values(params).join('/')

  const slug = paths === '' ? 'home' : paths.includes('//') ? 'path-not-correct' : paths.replace('preview/', '')
  // only the last part of the slug is sent to the api
  const slugParts = slug.split('/')
  const pageSlug = slugParts[slugParts.length - 1].toLowerCase()

  const isPreviewMode = paths.includes('preview/')

  const { data } = useContentAPI('entries', 'destinationPage', pageSlug, isPreviewMode)
  const { updateAdditionalFooterDisclaimer } = usePageInfoContext()

  const previewData = useContentfulLiveUpdates(data)

  // resolve response on getting all data
  useEffect(() => {
    if (!data || data === null) return
    if (!previewData || previewData === null) return

    if (count === 0) {
      setCount(1)
// Only proceed for HTTP 200 and 404
if (data?.status !== 200 && data?.status !== 404) return;

      if (data && data !== null) {
        const resolver = {
          items: isPreviewMode ? previewData?.data?.items : data?.data?.items,
          includes: isPreviewMode ? previewData?.data?.includes : data?.data?.includes,
        }

        const response = resolveResponse(resolver)

        if (response[0].fields?.redirectUrl) {
          window.location.href = response[0].fields?.redirectUrl
        }
        if (response[0].fields?.assetForFactsheets) {
          window.location.href = response[0].fields?.assetForFactsheets?.fields?.file.url
        }
        setContentData(response[0])
        updateAdditionalFooterDisclaimer(response[0]?.fields?.additionalFooterDisclaimer)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPreviewMode, data, previewData, count])

  const toggleTableShadow = () => {
    const tables = document.getElementsByTagName('table')
    for (let i = 0; i < tables.length; i++) {
      const tbody = tables[i].getElementsByTagName('tbody')[0].clientWidth
      const parent = tables[i].parentElement
      const eq = tbody === tables[i].parentElement.clientWidth
      const hs = tbody > tables[i].parentElement.clientWidth
      if (eq) {
        tables[i].classList.remove('scroll')
        parent.classList.remove('maxct')
      } else {
        if (hs) {
          tables[i].classList.add('scroll')
          parent.classList.remove('maxct')
        } else {
          tables[i].classList.remove('scroll')
          parent.classList.add('maxct')
        }
      }
    }
  }

  useEffect(() => {
    if (Object.keys(contentData).length === 0) return
    toggleTableShadow()
    window.addEventListener('resize', toggleTableShadow)
    return () => {
      window.removeEventListener('resize', toggleTableShadow)
    }
  }, [contentData])

  if (!contentData || Object.entries(contentData).length <= 0) {
    return <></>
  }

  return (
    <>
     <SEOProvider>
      {/* Meta Tags Starts */}
      <SEOMeta content={contentData} />
      {/* Meta Tags Ends */}
      <div id="main-content" className={`${contentData?.fields?.articlePage ? 'layoutArticle' : ''}`}>
        {/* The Banner component has been moved from the pageContainer content type to page level, so it is no longer matching with dynamic components. */}
        {contentData?.fields?.banner?.fields &&
          (() => {
            const { banner } = contentData?.fields
            const { fields, sys } = banner
            const { contentType } = sys

            return contentType?.sys?.id === 'pageBanner' ? (
              <PageBanner
                content={fields}
                background={fields?.backgroundVariantColor}
                breadcrumb={contentData?.fields}
                isArticle={contentData?.fields?.articlePage}
              />
            ) : (
              <HeroBanner content={fields} isArticle={contentData.fields?.articlePage} />
            )
          })()}
        <ContainerSection>
          {slug === 'search-results' && <SearchResults />}
          <DynamicComponent components={contentData} />
        </ContainerSection>
      </div>
      </SEOProvider>
    </>
  )
}

export default BaseTemplate
